"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var saveOrDiscardOptions_1 = require("../utils/saveOrDiscardOptions");
exports.saveOptions = satcheljs_1.orchestratorAction('saveOptions', function saveOptions() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 2, 3]);
                    owa_options_store_1.setIsSaving(true);
                    return [4 /*yield*/, saveOrDiscardOptions_1.default(true)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    owa_options_store_1.setIsSaving(false);
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/saveOptions.js
// module id = 5280
// module chunks = 2